export const isNull = (value: unknown): value is null => value === null;
